/**
 * Styled Components - Created by Jesús on 19/05/20.
 */
import styled from 'styled-components'
import Radio from 'antd/lib/radio'
import Button from 'antd/lib/button'
import Upload from 'antd/lib/upload'
import Checkbox from 'antd/lib/checkbox'
import { RED, GRAY_SOFT, BLUE, ORANGE, GRAY_LIGHT } from '../../theme/colors'
import { WHITE } from '../../screens/DesignerTool/constants'
import Icon from 'antd/lib/icon'

interface ContainerProps {
  withoutPadding?: boolean
  upperCase?: boolean
  highlight?: boolean
  disabled?: boolean
}

const RadioGroup = Radio.Group

export const Container = styled.section`
`

export const ModalContainer = styled.div`
  display: flex;
  flex-flow: column;
`

export const FormContainer = styled.div`
  display: flex;
  flex-flow: column;
  margin-top: 36px;
`

export const Title = styled.div`
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 10px;
  text-transform: uppercase;
`

export const Description = styled.div`
  font-size: 14px;
  margin-top: 10px;
`

export const Label = styled.div`
  font-weight: bold;
`

export const CurrencyContainer = styled.div`
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  margin: 16px 0;
  max-width: 338px;
  width: 100%;
`

export const RadioGroupStyled = styled(RadioGroup)`
`

export const RadioStyled = styled(Radio)`
  display: block;
  height: 30px;
  line-height: 30px;
  div {
    display: inline-block;
  }
`

export const Currencies = styled.div`
  height: 45px;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
`

export const FileLink = styled.button`
  border: none;
  text-align: left;
  color: ${RED};
  text-decoration: underline;
  cursor: pointer;
  background: none;
  :disabled {
    color: ${GRAY_SOFT};
    cursor: default;
  }
`

export const StyledUpload = styled(Upload)`
  margin-top: 4px;
  margin-bottom: 8px;
  .ant-upload-select-picture-card {
    border: 1px solid ${RED};
    width: 268px;
    height: 44px;
    margin-top: 10px;
    background: ${WHITE};
    border-radius: 1px;
    @media (max-width: 767px) {
      width: 100%;
      height: 54px;
    }
    @media (max-width: 692px) {
      width: 100%;
      height: 42px;
    }
  }
`

export const UploadButton = styled.div`
  color: ${RED};
  display: flex;
  align-items: center;
  margin-left: 16px;
  margin-right: 20px;
`

export const StyledIcon = styled(Icon)`
  margin-right: 16px;
`

export const Clip = styled(Icon)`
  color: ${RED};
  margin-right: 12px;
`

export const FileLabel = styled.div`
  display: flex;
`

export const FileName = styled.div`
  width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`

export const CheckboxContainer = styled.div`
  margin-top: 20px;
`

export const CheckboxLabel = styled.div`
  display: inline-block;
`

export const TermsLink = styled.span`
  color: ${BLUE};
  text-decoration: underline;
  font-weight: bold;
`

export const TermsLabel = styled.div`
  margin-bottom: 12px;
  max-width: 740px;
  a {
    text-decoration: underline;
    color: ${BLUE};
  }
`

export const ButtonsContainer = styled.div`
  margin-top: 8px;
  width: 100%;
  text-align: right;
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  @media (max-width: 767px) {
    flex-flow: column-reverse;
    margin-top: 12px;
  }
`

export const CancelButton = styled(Button)`
  width: fit-content;
  border-radius: 5px;
  height: 32px;
  font-size: 12px;
  padding: 4px 44px;
  margin-top: 12px;
`

export const RemoveButton = styled(Button)`
  width: fit-content;
  margin-left: 18px;
  border-radius: 5px;
  height: 32px;
  font-size: 12px;
  padding: 4px 14px;
  margin-top: 12px;
  box-shadow: 1px 2px 4px -2px #c4c4c4;
  background: #ffefef;
  @media (max-width: 767px) {
    margin-left: 0px;
  }
`

export const LinkButton = styled(Button)`
  width: fit-content;
  border-radius: 5px;
  height: 32px;
  color: ${WHITE};
  background: ${BLUE};
  box-shadow: 1px 2px 4px -1px #afafaf;
  border: none;
  font-size: 12px;
  padding: 4px 14px;
  margin-top: 12px;
`

export const SaveButton = styled.div`
  display: inline-block;
  padding: 10px 54px;
  border-radius: 4px;
  background: rgb(68, 104, 249);
  margin-right: 18px;
  color: ${WHITE};
  transition: all .25s;
  box-shadow: 1px 2px 4px -1px #989898;
  &:hover {
    opacity: 0.7;
    cursor: pointer;
  }
  ${({ disabled }: ContainerProps) => disabled ? `
    background: ${GRAY_LIGHT};
    &:hover {
      opacity: 1;
      cursor: not-allowed;
    }
  ` : ''}
`

export const BottomInputs = styled.div`
  display: flex;
  align-items: flex-end;
  @media (max-width: 698px) {
    flex-flow: column;
    align-items: center;
  }
`

export const FileInput = styled.div`
  ${({ highlight }: ContainerProps) => highlight ? `
    animation: blink-3 0.75s 0.25s 4 ease-in-out;
    @keyframes blink-3 {
      0% {
        box-shadow: 0 0 0 0 #fd9b9b;
      }
      100% {
        box-shadow: 0 0 4px 16px #ffebeb24;
      }
    }
    ` : ''}
`

export const CheckboxStyled = styled(Checkbox)`
  @media (max-width: 698px) {
    margin-bottom: 14px;
  }
  ${({ highlight }: ContainerProps) => highlight ? `
    animation: blink-3 0.75s 0.25s 4 ease-in-out;
    @keyframes blink-3 {
      0% {
        box-shadow: 0 0 0 0 #fd9b9b;
      }
      100% {
        box-shadow: 0 0 4px 16px #ffebeb24;
      }
    }
    ` : ''}
`

export const Title2 = styled.div`
  display: flex;
  margin-top: 4px;
`

export const LabelButton = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-start;
  margin-left: 48px;
  position: relative;
  border: 1px solid #dc8c8c;
  border-radius: 3px;
  padding: 8px 12px;
  height: fit-content;
  margin-bottom: 7px;
  ${({ highlight }: ContainerProps) => highlight ? `
    animation: blink-3 0.75s 0.25s 4 ease-in-out;
    @keyframes blink-3 {
      0% {
        box-shadow: 0 0 0 0 #fd9b9b;
      }
      100% {
        box-shadow: 0 0 4px 16px #ffebeb24;
      }
    }
  ` : ''}
  @media (max-width: 698px) {
    margin-top: 22px;
    margin-left: 0;
  }
`

export const BoldLabel = styled.div`
  font-weight: bold;
  margin-top: 6px;
  text-transform: ${({ upperCase }: ContainerProps) => upperCase ? 'uppercase' : ''};
`

export const PaypalLogo = styled.img`
  text-align: center;
  object-fit: contain;
  width: 68px;
  margin-bottom: 6px;
  position: absolute;
  top: -10px;
  background: white;
  padding: 0 4px;
`

export const WarningIcon = styled(Icon)`
  margin-right: 8px;
  font-size: 16px;
  color: ${ORANGE};
`

export const WarningLabel = styled.div`
  font-size: 12px;
  font-style: italic;
  font-weight: normal;
  @media (max-width: 1024px) {
    margin-top: 8px;
  }
`

export const RedLabel = styled.div`
  color: red;
  cursor: pointer;
  margin-left: 28px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/AffiliateModal/styledComponents.tsx